module.exports = __webpack_public_path__ + "static/media/capa-comparativo.09f2ccaf.jpg";